import { render, staticRenderFns } from "./CellRendererActionsTestResults.vue?vue&type=template&id=2afabca2"
import script from "./CellRendererActionsTestResults.vue?vue&type=script&lang=js"
export * from "./CellRendererActionsTestResults.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActionsTestResults.vue?vue&type=style&index=0&id=2afabca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports